
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { ZohoLinkedService } from 'app/model/linkedservice/zoho.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'ZohoObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.Zoho_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.Zoho_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: ZohoLinkedService.MODEL // Linked service redefined
        }
    }
})
export class ZohoObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
